import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useShowToast } from '../../../redux/slices/toasts/hooks';
import { editorMessages } from '../messages/editorMessages';
import type { MusicVideoDocLimit } from './docLimits';

const LIMIT_MESSAGES = {
  clips: editorMessages.limitClips,
  size: editorMessages.limitSize,
} as const;

/** Shows a short note each time the document refused a change over a stored limit (`docLimitRefusal`). */
export function useDocLimitNote(refused: MusicVideoDocLimit | null, refusedCount: number): void {
  const intl = useIntl();
  const toast = useShowToast();
  const shown = useRef(refusedCount);
  useEffect(() => {
    if (refusedCount === shown.current || refused === null) {
      return;
    }
    shown.current = refusedCount;
    toast.showInfo(intl.formatMessage(LIMIT_MESSAGES[refused]));
  }, [intl, refused, refusedCount, toast]);
}
